export enum ProjectOAuth2OidcPrompt {
    None = 'none',
    Login = 'login',
    Consent = 'consent',
    SelectAccount = 'select_account',
}
